import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import TosAgreementsAdmin from 'pages/Landing/admin/TosAgreementsAdmin'

export const Route = createFileRoute('/_auth/_global/tos-agreements')({
  beforeLoad: requireGlobalRole(GlobalRoleType.GLOBAL_ADMIN),
  component: TosAgreementsAdmin,
})
